﻿let reset = false;
var table;
const History = window.History; // Note: We are using a capital H instead of a lower h
function getActiveCO2Buttons() {
    const greenButtons = $('[data-co2] a.btn-green');

    const values = $.map(greenButtons, function (element, index) {
        return $(element).attr('value');
    });

    return values.join(',');
}

function handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== 'undefined') {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;

        console.log('TextDiv Height:', textDivHeight); // Debugging: Check the height

        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) {
                existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            }

            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);

            toggleBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 1.2 * 16) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });

            console.log('Toggle Button Added'); // Debugging: Confirm button is added
        }
    } else {
        console.log('TextDiv not found'); // Debugging: Check if textDiv is found
    }
}

function getActiveNOxButtons() {
    const greenButtons = $('[data-urban-NOx] a.btn-green');

    const values = $.map(greenButtons, function (element, index) {
        return $(element).attr('value');
    });

    return values.join(',');
}

//sorting the results
function sortResults(event) {
    event.preventDefault();

    const newSortBy = $(this).data('air-index-tool-sort');
    const sortByEl = $('#SortBy');
    const sortDescEl = $('#SortDesc');
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy !== newSortBy || sortDesc.toLowerCase() === "true") {
        sortDescEl.val("false");
    } else {
        sortDescEl.val("true");
    }
    window.updateAirIndexToolResults();
}

function getData(page) {
    const manufacturerId = $('#ManufacturerId').val();
    const modelGroupId = $('#ModelGroupId').val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const year = $('#Year').val();
    const bodyStyle = $('#BodyStyle').val();
    const engine = $('#Engine').val();
    const co2 = getActiveCO2Buttons();
    const urbanNOx = getActiveNOxButtons();
    const searchTerm = $('#SearchTerm').val();
    const sortBy = $('#SortBy').val();
    const sortDesc = $('#SortDesc').val();

    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturer,
        Model: model,
        Year: year,
        BodyStyle: bodyStyle,
        Engine: engine,
        CO2Rating: co2,
        UrbanNoxRating: urbanNOx,
        SearchTerm: searchTerm,
        SortBy: sortBy,
        SortDesc: sortDesc,
        P: page
    };
}

function buildUpQueryString(data) {
    let queryString = "";

    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.Manufacturer}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.Model}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `Year=${data.Year}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `BodyStyle=${data.BodyStyle}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `Engine=${data.Engine}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `CO2Rating=${data.CO2Rating}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `UrbanNOxRating=${data.UrbanNoxRating}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `SearchTerm=${data.SearchTerm}`;

    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }

    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;

    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;

    return `?${queryString}`;
}

//asc & desc sorting
function applyResultsSortArrows() {
    const sortBy = $('#SortBy').val();
    $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $('#SortDesc').val();
    if (sortDesc.toLowerCase() === "true") {
        $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
    }
}

//load the datatable for low res
function loadAsDataTable() {
    table = $('#air-index-results-table').DataTable({
        "columns": [
            {
                "className": 'dt-control',
                "orderable": false,
                "data": null,
                "defaultContent": ''
            },
            { "data": "make" },
            { "data": "fuel" },
            { "data": "year" },
            { "data": "engine" },
            { "data": "bhp" },
            { "data": "euro" },
            { "data": "co2" },
            { "data": "nox" },
            { "data": "compare" }
        ],
        "order": [[1, 'asc']],
        searching: false,
        paging: false,
        "info": false,
        responsive: true,
        "ordering": false
    });


    //const table = $('#air-index-results-table').DataTable({
    //    "columns": [
    //        {
    //            "className": 'dt-control',
    //            "orderable": false,
    //            "data": null,
    //            "defaultContent": ''
    //        },
    //        { "data": "make" },
    //        { "data": "fuel" },
    //        { "data": "year" },
    //        { "data": "engine" },
    //        { "data": "bhp" },
    //        { "data": "euro" },
    //        { "data": "co2" },
    //        { "data": "nox" },
    //        { "data": "compare" }
    //    ],
    //    "order": [[1, 'asc']],
    //    searching: false,
    //    paging: false,
    //    "info": false,
    //    responsive: true
    //});
}

function updateResultsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
    //hideInitialBodyContent();
}

function getPage(href) {
    const querystring = href.split('?')[1];
    const parts = querystring.split('&');
    return $.grep(parts, function (el, index) {
        return el.split('=')[0] === "p";
    })[0].split('=')[1];
}

function setManufacturer(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ManufacturerId') > 1) {
            const manId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get(`/manufacturer-url/${manId}`, function (response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf('Manufacturer') > 1) {
            const manufacturer = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Manufacturer";
            })[0].split('=')[1];

            $("#Manufacturer").val(manufacturer);
        }
    }
}


function setModel(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ModelGroupId') > 1) {
            const modelId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ModelGroupId";
            })[0].split('=')[1];
            const manufacturerId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get(`/model-url/${manufacturerId}/${modelId}`, function (response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf('Model') > 1) {
            const model = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Model";
            })[0].split('=')[1];

            $("#Model").val(model);
        }
    }
}

function markAsLoading() {
    $('#air-index-tool-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function pageData(event) {
    event.preventDefault();
    if ($(this).attr('href') === undefined)
        return;
    const page = getPage($(this).attr('href'));
    updateResultsLogic(page);
}


//adding to compare list
function addVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/add/${id}`, function (response) {
        let success;
        if (response === 0) {
            success = true;
        } else if (response === 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response === 2) {
            success = true;
        } else {
            alert("Error");
            success = false;
        }
        if (callback) {
            callback(success);
        }
    });
}

function removeVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/remove/${id}`, function (response) {
        const success = response === 0;
        if (callback) {
            callback(success);
        }
    });
}

function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({ cache: false });
    $.get('/emissions-data/query', State.data, function (response) {
        $('#air-index-tool-query-container').replaceWith(response);
        handleBodyCopyToggle();
    });
}

function markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text('Compare');
}

function markAsToRemove(btn) {
    btn.html(btn.data('original-text'));
    btn.addClass("added");
    btn.text("Comparing");
}

function updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("air-index-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data('original-text')) {
        btn.data('original-text', btn.html());
    }

    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) {
        removeVehicle(data, function (success) {
            if (success) {
                markAsToAdd(btn);
                reloadQuery();
            } else {
                markAsToRemove(btn);
            }
            reloadQuery();
        });
    } else {
        addVehicle(data, function (success) {
            if (success) {
                markAsToRemove(btn);
                $("html, body").animate({ scrollTop: $("#air-index-tool-query-container").offset().top }, "slow");
                reloadQuery();
            } else {
                markAsToAdd(btn);
            }
        });
    }
}

function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val('');
        $("#Model").val('');
        $.get(`/manufacturer-url/${$(this).val()}`, function (response) {
            $("#Manufacturer").val(response);
            window.updateAirIndexToolResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$('#ManufacturerId').val()}`, function (response) {
                $("#Manufacturer").val(response);
            });
            $.get(`/model-url/${$('#ManufacturerId').val()}/${$(this).val()}`, function (response) {
                $("#Model").val(response);
                window.updateAirIndexToolResults();
            });
        } else {
            $("#Model").val('');
            window.updateAirIndexToolResults();
        }
    } else {
        window.updateAirIndexToolResults();
    }
}

function updateCO2Buttons(event) {
    $(event.target).toggleClass('btn-green').toggleClass('btn-primary');
    event.preventDefault();
    window.updateAirIndexToolResults();
}

function updateUrbanNOxButtons(event) {
    $(event.target).toggleClass('btn-green').toggleClass('btn-primary');
    event.preventDefault();
    window.updateAirIndexToolResults();
}

function updateState() { // Note: We are using statechange instead of popstate#
    markAsLoading();
    reloadQuery();
    const State = History.getState();
    $.get('/emissions-data/results', State.data, function (response) {
        $('#air-index-tool-results-container').replaceWith(response);
        $("#air-index-tool-results-container input[name^='comparelist']").each(function () {
            const compareListId = $(this).val();
            $(`[data-air-index-compare-list-add-id=${compareListId}]`).addClass("added").text('Comparing');
        });

        loadAsDataTable();
        applyResultsSortArrows();
        if (reset) {
            $('[data-no-results]').hide();
            $('#initial-result').html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
            reset = false;
        }
        //hideInitialBodyContent(true);
    });
}
function oneDecimalPlace(x) {
    return Number.parseFloat(x).toFixed(1);
}
/* Formatting function for row details - modify as you need */
function format(id) {
    var jqXHR = $.ajax({
        url: `/emissions-data/get/${id}`,
        type: 'GET',
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    var details = $.ajax({
        url: `/emissions-data/get-url/${id}`,
        type: 'GET',
        async: false
    });

    var airco2Rating = "";
    var co2RatingStandard = "";
    if (obj.airCO2Rating === "A") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airCO2Rating + '</span></div>';
        co2RatingStandard = "0 - 95 g/km";
    }
    else if (obj.airCO2Rating === "B") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airCO2Rating + '</span></div>';
        co2RatingStandard = "95 - 130 g/km";
    }
    else if (obj.airCO2Rating === "C") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airCO2Rating + '</span></div>';
        co2RatingStandard = "130 - 180 g/km";
    }
    else if (obj.airCO2Rating === "D") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airCO2Rating + '</span></div>';
        co2RatingStandard = "180 - 230 g/km";
    } else if (obj.airCO2Rating === "E") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airCO2Rating + '</span></div>';
        co2RatingStandard = "230+ g/km";
    }

    var urbanNoxRating = "";
    var urbanNoxStandardRating = "";
    if (obj.airUrbanNoxRating === "A") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airUrbanNoxRating + '</span></div>';
        urbanNoxStandardRating = "0 - 80 mg/km";
    }
    else if (obj.airUrbanNoxRating === "B") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airUrbanNoxRating + '</span></div>';
        urbanNoxStandardRating = "80 - 168 mg/km";
    }
    else if (obj.airUrbanNoxRating === "C") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airUrbanNoxRating + '</span></div>';
        urbanNoxStandardRating = "168 - 270 mg/km";
    }
    else if (obj.airUrbanNoxRating === "D") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airUrbanNoxRating + '</span></div>';
        urbanNoxStandardRating = "270 - 600 mg/km";
    } else if (obj.airUrbanNoxRating === "E") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airUrbanNoxRating + '</span></div>';
        urbanNoxStandardRating = "600+ mg/km";
    }
    var mobileData = "";
    if (window.isViewportLessThan('md')) {
        mobileData = '<tr class="d-md-none">' +
            '<td>Fuel</td>' +
            '<td>' +
            obj.fuelType +
            '</td>' +
            '</tr>' +
            '<tr class="d-md-none">' +
            '<td>Year</td>' +
            '<td>' +
            obj.modelYear +
            '</td>' +
            '</tr>' +
            '<tr class="d-md-none">' +
            '<td>Engine</td>' +
            '<td>' +
            obj.engineCC +
            'cc</td>' +
            '</tr>' +
            '<tr class="d-md-none">' +
            '<td>BHP</td>' +
            '<td>' +
            obj.powerBhp +
            'bhp</td>' +
            '</tr>' +
            '<tr class="d-md-none">' +
            '<td>Euro</td>' +
            '<td>' +
            obj.euroStage +
            '</td>' +
            '</tr>';
    }

    var extraData = "";
    if (obj.officialNedcMpg != null) {
        extraData += '<tr>' +
            '<td>Official NEDC mpg</td>' +
            '<td>' +
            oneDecimalPlace(obj.officialNedcMpg) +
            ' mpg</td>' +
            '</tr>';
    }

    if (obj.officialWltpMpg != null) {
        extraData += '<tr>' +
            '<td>Official WLTP mpg</td>' +
            '<td>' +
            oneDecimalPlace(obj.officialWltpMpg) +
            ' mpg</td>' +
            '</tr>';
    }

    return '<div class="row additional-air-index-info">' +
        '<div class="col-md-4">' +
        '<table class="table">' +
        mobileData +
        '<tr class="drive">' +
        '<td>Drive</td>' +
        '<td>' + obj.driveTrain + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>Body type</td>' +
        '<td>' + obj.bodyStyle + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>Transmission</td>' +
        '<td>' + obj.transmission + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>Engine (Litres)</td>' +
        '<td>' + obj.engineL + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td>Power</td>' +
        '<td>' + obj.powerPS + 'bhp</td>' +
        '</tr>' +
        '<tr>' +
        '<td>Predicted fuel economy</td>' +
        '<td>' + oneDecimalPlace(obj.airMpg) + ' mpg<br/>' + oneDecimalPlace(obj.fuelEconomy) + ' litres/100km</td>' +
        '</tr>' +
        extraData +
        '</table>' +
        '<a href="' + details.responseText + '" class="btn btn-primary mb-3">More details</a>' +
        '</div>' +
        '<div class="col-md-4 px-lg-3 px-md-4">' +
        '<div class="mb-3">' +
        '<h4>Carbon dioxide (CO2)</h4>' +
        '</div>' +
        '<div class="mb-3">' +
        airco2Rating +
        '<div class="float-start">' +
        '<div class="margin-bottom-10">' +
        '<strong>Air Index range</strong> ' +
        '<br/>' +
        co2RatingStandard +
        '</div>' +
        '<strong>Official rating</strong>' +
        '<br/>' +
        '' + obj.officialCO2 + ' g/km ' +
        '</div>' +
        '<div class="clearfix"></div>' +
        '</div>' +
        '<div class="mb-2 mb-md-0"><strong> What is CO2? </strong> <br/> <small>Vehicles produce CO2 when they use fuel. The amount of CO2 produced is directly linked to how much fuel it consumes. Excess levels of CO2 can be harmful to humans and the environment.</small><br/></div><hr class="visible-xs"/>' +
        '</div>' +
        '<div class="col-md-4">' +
        '<div class="mb-3">' +
        '<h4>Urban NOx</h4>' +
        '</div>' +
        '<div class="mb-3">' +
        urbanNoxRating +
        '<div class="float-start">' +
        '<div class="mb-2">' +
        '<strong>Air Index range</strong> ' +
        '<br/>' +
        urbanNoxStandardRating +
        '</div>' +
        '</div>' +
        '<div class="clearfix"></div>' +
        '</div>' +
        '<div class="mb-2 mb-md-0"><strong> What is Urban NOx? </strong> <br/> <small>NOx refers to nitric oxide and nitrogen dioxide. They are released from vehicle engines and can reach harmful levels in towns and cities. They are an irritant and cause inflammation of the airways.</small><br/></div>' +
        '</div>' +
        '</div>';

}

function checkBodyContent(text) {
    if (text === 'Show more') {
        $('#data-air-index-body p:not(:first-child)').show(500);
        $('[data-air-index-tool-toggle]').text('Show less');
    } else {
        $('#data-air-index-body p:not(:first-child)').hide(500);
        $('[data-air-index-tool-toggle]').text('Show more');
    }
}

//function hideInitialBodyContent(delay) {
//    if (delay === true) {
//        setTimeout(function() {
//                $('#data-air-index-body p:not(:first-child)').hide(100);
//            },
//            300);
//    } else {
//        $('#data-air-index-body p:not(:first-child)').hide();
//    }
//}

export function setupAirIndexTool() {
    if (!$('[data-air-index-tool]').length) {
        return;
    }
    //hideInitialBodyContent(false);
    $(document).on('click', '[data-air-index-tool-toggle]', function (e) {
        e.preventDefault();
        var text = $(this).text();
        checkBodyContent(text);
    });
    $(document).on('click', '[data-showing-cars]', function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: $("#air-index-tool-results-container").offset().top - 120 }, "slow");
    });
    $('.slider4').bxSlider({
        slideWidth: 400,
        minSlides: 2,
        maxSlides: 3,
        moveSlides: 3,
        slideMargin: 30,
        pager: true
    });
    $(document).on("click", "#air-index-results-table tbody td.dt-control", function () {
        var tr = $(this).closest('tr');
        var row = table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data('item-id');
        if (row.child.isShown()) {

            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
        } else {
            // Open this row
            row.child(format(itemId)).show();
            tr.addClass('shown');
        }
        //if (row.child.isShown()) {
        //    if (window.isViewportLessThan('md')) {
        //        // Open this row
        //        row.child(format(itemId)).show();
        //        tr.addClass('shown');
        //    } else {
        //        // This row is already open - close it
        //        row.child.hide();
        //        tr.removeClass('shown');
        //    }
        //}
        //else {
        //    if (window.isViewportLessThan('md')) {
        //        // This row is already open - close it
        //        row.child.hide();
        //        tr.removeClass('shown');
        //    } else {
        //        // Open this row
        //        row.child(format(itemId)).show();
        //        tr.addClass('shown');
        //    }
        //}
    });
    $(document).on("click", "#air-index-results-table tbody td a.data-more-details", function (e) {
        e.preventDefault();
        var tr = $(this).closest('tr');
        var row = table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data('item-id');
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
        } else {
            // Open this row
            row.child(format(itemId)).show();
            tr.addClass('shown');
        }
    });
    setManufacturer(window.location.href);
    setModel(window.location.href);
    $('#initial-result').html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
    $('[data-no-results]').hide();
    loadAsDataTable();
    //$(document).on("click", "[data-view-detail]", showHideDetail);

    //add to compare list button click
    $(document).on("click", "[data-air-index-compare-list-add-id]", updateCompareList);

    //dropdown changes
    $(document).on('change', '[data-air-index-tool] input, [data-air-index-tool] select', onChangeFilters);

    $(document).on('keypress', '[data-air-index-tool] input', function (e) {
        if (e.keyCode === 13) {
            onChangeFilters();
            return false;
        }
    });
    //co2 button changes
    $(document).on('click', '[data-co2] a', updateCO2Buttons);
    //urban NOx button changes
    $(document).on('click', '[data-urban-NOx] a', updateUrbanNOxButtons);
    //paging click
    $(document).on('click', '#air-index-tool-results-container .pagination a', pageData);

    applyResultsSortArrows();

    $(document).on("click", "[data-air-index-tool-sort]", sortResults);

    $(document).on("click", "[data-reset-button]", function (event) {
        event.preventDefault();
        History.pushState({}, $('title').html(), location.pathname);
        reset = true;
    });

    window.updateAirIndexToolResults = function () {
        updateResultsLogic(1);
    }

    // Bind to StateChange Event
    History.Adapter.bind(window, 'statechange', updateState);
}